import React from 'react';
import { connect } from 'react-redux';
import { LimitContextProvider } from '../../../../../admin/contexts/LimitContext';
import MediaGallerySelector from '../../../../../admin/containers/MediaGallerySelector';
import { getSelectedMedium, setSelectedMedia } from '../../../store/modules/mediaGallery';

const ImageGallerySelectorEditor = ({ usedMedia, selectedMedium, setSelectedMedium }) => (
  <div>
    <LimitContextProvider>
      <MediaGallerySelector
        setSelectedMedium={setSelectedMedium}
        selectedMedium={selectedMedium}
        usedMedia={usedMedia}
        showTrash={false}
        showSearch
      />
    </LimitContextProvider>
  </div>
);
export default connect(
  state => ({
    selectedMedium: getSelectedMedium(state),
  }),
  { setSelectedMedium: setSelectedMedia },
)(ImageGallerySelectorEditor);
